module.exports = __webpack_public_path__ + "images/bd50921eb08a6090502c6a8f98e62a0f423caac10cf3e2c8f83225c84b507369.svg";